export const getTabByAnchorInside = (
  anchor: string | Node,
): HTMLElement | null => {
  const anchorTargetElement =
    anchor instanceof Node
      ? anchor
      : document.querySelector(
          '[data-combo-name="Tabs"] [data-anchor-target="' + anchor + '"]',
        );

  if (!(anchorTargetElement instanceof HTMLElement)) return null;

  const tabsCombo = anchorTargetElement.closest('[data-combo-name="Tabs"]');
  if (!(tabsCombo instanceof HTMLElement)) return null;

  const set = anchorTargetElement.classList.contains("set")
    ? anchorTargetElement
    : anchorTargetElement.closest(".set");

  if (!(set instanceof HTMLElement)) return null;

  const setLayerId = set.getAttribute("data-layer-id");
  if (!setLayerId) return null;

  const tab = tabsCombo.querySelector(`[data-tab-id="${setLayerId}"]`);

  if (!(tab instanceof HTMLElement)) return null;

  return tab;
};
